/* eslint-disable quotes */
export const routes = {
  unAuthorizedAccess: "unAuthorizedAccess",
  notfound: "notfound",
  error: "error",
  aboutUs: "aboutUs",
  employee: "employees",
  market: "markets",
  property: "properties",
  assignments: "assignments",
  allocations: "allocations",
  transition: "transition",
  ptfDetail: "ptfDetail",
  ptf: "ptf",
  dashboard: "dashboard",
  pendingRequests: "pendingRequests",
  pendingNotifications: "pendingNotifications",
  configurations: "configurations",
  reports: "reports",
  reimbursementVarianceAnalysis: "reimbursementVarianceAnalysis",
  fileViewer: 'fileViewer',
  clients: 'clients',
  employeeTerminations: "employeeTerminations",
  overtimeAttendance: "overtimeAttendance",
  employeeOvertimeAttendanceSheet: 'employeeOvertimeAttendanceSheet',
  billingAccountingAdjustments: 'billingAccountingAdjustments',
  closePayPeriod: 'closePayPeriod',
  compliance: 'compliance',
  employeeYearlyBonus: 'employeeYearlyBonus',
  yearlyBonusAccrual: 'yearlyBonusAccrual',
  yearEndBonusCompliance: 'yearEndBonusCompliance',
  closeYearEndBonus: 'closeYearEndBonus',
  propertyTenantCountMapping: 'propertyTenantCountMapping'
};
